export default "__VITE_ASSET__DH3N5ZI5__"